export interface CountdownParts {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  expired: boolean;
}

/** Split the distance between two instants into stable countdown units. */
export function countdownParts(target: Date, now: Date): CountdownParts {
  const raw = target.getTime() - now.getTime();
  const expired = raw < 0;
  let remaining = Math.abs(raw);
  if (!Number.isFinite(remaining)) remaining = 0;

  const days = Math.floor(remaining / 86_400_000);
  remaining %= 86_400_000;
  const hours = Math.floor(remaining / 3_600_000);
  remaining %= 3_600_000;
  const minutes = Math.floor(remaining / 60_000);
  const seconds = Math.floor((remaining % 60_000) / 1_000);

  return { days, hours, minutes, seconds, expired };
}
